import cn from 'classnames'

// "Thinking energy" indicator — soft visual. Green/full while the player talks,
// draining toward amber/red as they go quiet. Width animates with the energy value.
export const EnergyBar = ({
  energy,
  speaking,
  dimmed,
}: {
  energy: number
  speaking: boolean
  dimmed: boolean
}) => {
  const pct = Math.max(0, Math.min(100, energy))
  const color = dimmed ? 'bg-red-400' : pct < 55 ? 'bg-amber-400' : 'bg-[#398874]'

  return (
    <div className="w-full">
      <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
        <span>Thinking energy</span>
        <span className={cn('transition-opacity', speaking ? 'opacity-100 text-[#398874]' : 'opacity-40')}>
          ● {speaking ? 'hearing you' : 'listening…'}
        </span>
      </div>
      <div className="h-3 w-full rounded-full bg-gray-200 overflow-hidden">
        <div
          className={cn('h-full rounded-full transition-width duration-200 ease-linear', color)}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
